function initSwiper() {
  const container = document.querySelector('.products-slider');
  const totalSlides = container.querySelectorAll('.swiper-slide').length;
  const initialSlide = Math.max(0, Math.floor((totalSlides - 1) / 2));

  const prevBtn = document.querySelector('.prev-slide');
  const nextBtn = document.querySelector('.next-slide');

  var swiper = new Swiper(".products-slider", {
    slidesPerView: 2,
    speed: 600,
    spaceBetween: 0,
    centeredSlides: true,
    loop: false,
    initialSlide: initialSlide,
    breakpoints: {
      // when window width is >= 750px
      750: {
          slidesPerView: 5,
          spaceBetweenSlides: 10
      }
    }
  });

  // helper to update button state
  function updateNavButtons() {
    if (swiper.activeIndex === 0) {
      prevBtn.disabled = true;
    } else {
      prevBtn.disabled = false;
    }
    if (swiper.activeIndex === totalSlides - 1) {
      nextBtn.disabled = true;
    } else {
      nextBtn.disabled = false;
    }
  }

  // Event listeners for custom behavior
  document.querySelector('.next-slide').addEventListener('click', () => {
    swiper.slideNext();
  });
  document.querySelector('.prev-slide').addEventListener('click', () => {
    swiper.slidePrev();
  });

  // Swiper event listener
  swiper.on('slideChange', function () {
    let activeSlide = swiper.slides[swiper.activeIndex];
    let activeIndex = activeSlide.getAttribute("data-index");

    // Remove active class from all slides and tab content
    document.querySelectorAll(".swiper-slide").forEach(tab => tab.classList.remove("active"));
    document.querySelectorAll(".tab-content").forEach(content => content.classList.remove("active"));
    document.querySelectorAll(".bubble-label-wrapper").forEach(content => content.classList.remove("active"));
    document.querySelectorAll(".image-shadow-wrapper").forEach(content => content.classList.remove("active"));

    // Set active class on the correct tab and content
    document.querySelector(`.swiper-slide[data-index='${activeIndex}']`)?.classList.add("active");
    document.querySelector(`.tab-content[data-index='${activeIndex}']`)?.classList.add("active");
    document.querySelector(`.bubble-label-wrapper[data-index='${activeIndex}']`)?.classList.add("active");
    document.querySelector(`.image-shadow-wrapper[data-index='${activeIndex}']`)?.classList.add("active");

    // Update button states
    updateNavButtons();
  });

  // Handle Tab Click Event
  document.querySelectorAll(".swiper-slide").forEach(tab => {
    tab.addEventListener("click", function () {
      let index = parseInt(this.getAttribute("data-index")) - 1;
      swiper.slideTo(index);
    });
  });

  // Initialize button state immediately
  updateNavButtons();
}
// Initialize Swiper on page load
window.onload = initSwiper;

document.querySelectorAll('.add-to-cart').forEach(button => {
  button.addEventListener('click', function() {
    if (this.classList.contains('loading')) {
      // Prevent multiple clicks while loading
      return;
    }
    this.classList.add('loading');

    // Simulate async operation like add-to-cart API call
    setTimeout(() => {
      this.classList.remove('loading');
    }, 500);
  });

});